import { useEffect, useState } from 'react';
import { useAuth } from '../lib/AuthContext.js';
import { ApiClient } from '../lib/api.js';

const PLANS = [
  { id: 'creator', name: 'Creator', price: '$19', period: '/mo', features: ['500 generations / month', '10 keyword monitors', 'Daily radar scans', 'Chrome extension'] },
  { id: 'pro',     name: 'Pro',     price: '$49', period: '/mo', features: ['1,500 generations / month', '30 keyword monitors', 'Hourly radar scans', 'Thread mode', 'Priority queue'] },
  { id: 'team',    name: 'Team',    price: '$99+', period: '/mo', features: ['Multiple X accounts', 'Team seats', 'Shared prompts', 'Approval workflow'] },
];

export function Billing() {
  const { getToken } = useAuth();
  const api = new ApiClient(getToken);
  const [me, setMe] = useState<any>(null);

  useEffect(() => { api.me().then(setMe).catch(console.error); /* eslint-disable-next-line */ }, []);

  async function upgrade(plan: string) {
    const r = await api.checkout(plan);
    if (r.mock) {
      alert('Mock upgrade applied. Reloading.');
      window.location.reload();
    } else if (r.url) {
      window.location.href = r.url;
    }
  }
  async function portal() {
    const r = await api.portal();
    window.location.href = r.url;
  }

  const currentPlan = me?.user?.plan ?? 'free';

  return (
    <div className="page">
      <div className="page-head">
        <h1>Billing</h1>
        <p className="lede">Current plan: <strong>{currentPlan}</strong> · status: {me?.user?.subscriptionStatus ?? 'none'}</p>
      </div>

      <div className="grid">
        {PLANS.map(p => {
          const isCurrent = currentPlan === p.id;
          return (
            <div className="card plan" key={p.id}>
              <h3>{p.name}</h3>
              <div className="price">{p.price}<span style={{ fontSize: 14, color: 'var(--muted)', fontWeight: 400 }}>{p.period}</span></div>
              <ul>{p.features.map(f => <li key={f}>{f}</li>)}</ul>
              <button
                className={isCurrent ? '' : 'primary'}
                onClick={() => upgrade(p.id)}
                disabled={isCurrent}
              >
                {isCurrent ? 'Current plan' : `Upgrade to ${p.name}`}
              </button>
            </div>
          );
        })}
      </div>

      {me?.user?.stripeCustomerId && (
        <div className="card">
          <div className="button-row between">
            <div>
              <strong>Manage your subscription</strong>
              <div className="muted small">Update payment method, cancel, or download invoices.</div>
            </div>
            <button onClick={portal}>Open Stripe portal</button>
          </div>
        </div>
      )}
    </div>
  );
}
